module.exports = __webpack_public_path__ + "assets/img/lamp@1,5x.f0471547.svg";